import { render, staticRenderFns } from "./worldMap.vue?vue&type=template&id=16618604&scoped=true&"
import script from "./worldMap.vue?vue&type=script&lang=js&"
export * from "./worldMap.vue?vue&type=script&lang=js&"
import style0 from "./worldMap.vue?vue&type=style&index=0&id=16618604&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16618604",
  null
  
)

export default component.exports